import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { bandProperties, errors } = copy;

export const fields: IFormFields = [
  {
    name: "title",
    label: bandProperties.name.title,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
  },
];

export const defaultValues = {};
